import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys.ts';
import { supabase } from '../../lib/supabase.ts';

export interface WorkspaceDetails {
  id: string;
  name: string;
  slug: string;
  plan: string;
  timezone: string;
  active: boolean;
  default_assignee_user_id: string | null;
  sending_enabled: boolean;
  sending_blocked_reason: string | null;
}

export async function fetchWorkspace(workspaceId: string): Promise<WorkspaceDetails> {
  const { data, error } = await supabase()
    .from('workspaces')
    .select(
      'id, name, slug, plan, timezone, active, default_assignee_user_id, sending_enabled, sending_blocked_reason',
    )
    .eq('id', workspaceId)
    .single();
  if (error) throw new Error(`Couldn't load the workspace: ${error.message}`);
  return data;
}

export function useWorkspaceQuery(workspaceId: string) {
  return useQuery({
    queryKey: queryKeys.workspace(workspaceId),
    queryFn: () => fetchWorkspace(workspaceId),
  });
}
